import React, { useEffect } from "react";
import useStyles from "./styles";
import Tabs from '@material-ui/core/Tabs';
import Tab from '@material-ui/core/Tab';
import PropTypes from "prop-types";
import { withRouter, useHistory, useLocation } from "react-router-dom";

function TabNavigationCtrlFilterPanel({ headerFilter, controlArea, children, subRoutes, controlAreaClassName, ...props}) {
    
    const classes = useStyles();
    const history = useHistory();
    const location = useLocation();
    const [currentRoute, setCurrentRoute] = React.useState(0);

    useEffect(() => {
        subRoutes.forEach((s, index) => {
            if (s.href === location.pathname) {
                setCurrentRoute(index);
            }
        });
    }, [subRoutes, location])

    const handleChangeRoute = (event, index) => {
        history.push(subRoutes[index].href);
    };

    return <div {...props} className={classes.TabNavigationCtrlFilterPanel}>
        
        <div className={classes.navigation}>
            <div className={classes.navigationRoutes} style={{marginTop: '10px'}}>
                <Tabs
                    TabIndicatorProps={{
                        style: {
                            height: '6px',
                            backgroundColor: "#658D1B",
                            
                        }
                    }}
                    className={classes.navigationRoutesTabs}
                    value={currentRoute}
                    onChange={handleChangeRoute}
                >
                    {subRoutes.map((s, index) => (
                        <Tab className={classes.navigationRoutesTabsTab} label={s.title} key={index}/>
                    ))}
                </Tabs>
            </div>
            {controlArea && <div className={`${classes.navigationControls} ${controlAreaClassName}`}>{controlArea}</div>}
        </div>
        {headerFilter && <div>{headerFilter}</div>}
        <div>{children}</div>
    </div>;
}

TabNavigationCtrlFilterPanel.propTypes = {
    children: PropTypes.object.isRequired,
    subRoutes: PropTypes.array.isRequired,
    controlArea: PropTypes.object,
    headerFilter: PropTypes.object,
    controlAreaClassName: PropTypes.string,
};

TabNavigationCtrlFilterPanel.defaultProps = {
    controlAreaClassName: '',
    controlArea: null,
    headerFilter: null,
};

export default withRouter(TabNavigationCtrlFilterPanel);